module.exports = __webpack_public_path__ + "static/media/enlil_logo.a8acd39f.svg";